/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { useEffect, useState } from 'react';
import styles from '../../styles/Home.module.css';
import { FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import Loading from '../02-molecules/Loading';
import { trees } from '../../config';
import FROutputCallbackBasedView from '../forms/common/FROutputCallBackBasedView';
import SuspendMessage from '../forms/common/SuspendMessage.tsx';
import ErrorMessage from '../01-atoms/ErrorMessage';
import { MessageType } from '../modals/SuccessErrorModal';
import {setIsValueChanged} from '../../redux/watchNavigationSlice';
import { store } from '../../redux/store';
import { myprofileInterface } from '../forms/common/MyProfileInterface';
// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';

const AddCompany = ({setIsSuccessOpen,setSuccessMesssage}: myprofileInterface ) => {
    const tree = trees.addCompany;
    const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
    const [messageType, setMessageType] = useState(MessageType.info);
  const [message, setMessage] = useState('');  
  const [isAlertOpen, setIsAlertOpen] = useState(false);

    useEffect(() => {
        (async function getStep() {
            try {
                const initialStep = await FRAuth.start({ tree });
                setStep(initialStep);
            } catch (err) {
                console.error(`Error: request for initial step; ${err}`);
            }
        })();
    }, []);

    useEffect(() => {
        if (step && step.type === StepType.Step) {
            let stage =  step.getStage();
            if( !isNil(stage) && stage === 'SuspendMessage') {
                setIsSuccessOpen(true);
                setSuccessMesssage('Company Selected Successfully')
            }
        } 
        // else if (step && step.type === StepType.LoginFailure) {
        //     window.location.reload()
        // }
    }, [step]);

    const getAddCompanyView = () => {
        let uiElement: JSX.Element = <Loading size={100} />;
        if (step && step.type === StepType.Step) {
            switch (step.getStage()) {
                case 'AddCompany':
                    uiElement =
                        <FROutputCallbackBasedView  step={step as FRStep} setStep={setStep}
                        tree={tree} messageType={messageType} setMessageType={setMessageType}
                        message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} 
                        setIsAlertOpen={setIsAlertOpen} uiStage="BlockNavigation" fullWidthSave={true} />

                    break;
                case 'SuspendMessage':
                    store.dispatch(setIsValueChanged(false));
                    uiElement = <SuspendMessage step={step as FRStep} />;
                    break;
            }
        } else if (step && step.type === StepType.LoginFailure) {
            uiElement= <ErrorMessage />
        }
        return uiElement;

    }


    return (
        <>
                {getAddCompanyView()}
            </>
    )
}

export default AddCompany;